import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=78194a6a&scoped=true&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&id=78194a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78194a6a",
  null
  
)

export default component.exports